import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmationDialog } from 'app/components';
import { translations } from 'locales/i18n';

interface DeleteDialogProps {
  open: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export const DeleteDialog = ({ open, handleClose, onConfirm }: DeleteDialogProps) => {
  const { t } = useTranslation();
  return (
    <ConfirmationDialog
      open={open}
      title={t(translations.pages.billingFinance.confirmationDialog.deleteTitle())}
      onClose={handleClose}
      onConfirm={onConfirm}
    >
      {t(translations.pages.billingFinance.confirmationDialog.deleteDialog())}
    </ConfirmationDialog>
  );
};
